import { render, staticRenderFns } from "./PconEditBomChild.vue?vue&type=template&id=1b7f8ca2&scoped=true&"
import script from "./PconEditBomChild.vue?vue&type=script&lang=js&"
export * from "./PconEditBomChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f8ca2",
  null
  
)

export default component.exports